import { h, FunctionalComponent } from 'preact'
import cn from 'classnames'
import s from './Label.css'

interface iProps {
  color?: 'green' | 'gray'
}

const Label:FunctionalComponent<iProps> = ({ children, color = 'gray' }) => {
  return (
    <span className={cn(s.Label, {
      [s.Label_gray]: color === 'gray',
      [s.Label_green]: color === 'green',
    })}>
      {children}
    </span>
  )
}

export default Label
